import React, { useState, useEffect, useRef } from "react";
import NotificationsMenu from "./NotificationsMenu";
import { Container } from './styles.jsx';
import Api, { exceptionNotificationAPI } from "../../services/api";
import moment from "moment";

const NotificationMenu = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);
  const dataRef = useRef(data);

  useEffect(() => {
    getData()
  }, []);


  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  useEffect(() => {
    const timer = setInterval(async () => {    
      const user = JSON.parse(localStorage.getItem('@QualityApp:user'));

       const lastDate = dataRef.current && dataRef.current.length > 0
        ? dataRef.current.reduce((max, n) => n.created > max ? n.created : max, dataRef.current[0].created)
        : null;

      const params = lastDate ? `?lastDate=${encodeURIComponent(lastDate)}` : '';

      await Api.get(`Notification/GetNewNotificationsByUserId${params}`).then((result) => {
        if (result && result.data && result.data.response && Array.isArray(result.data.response)) {
          var list = [];
          var countNotRead = count;
          result.data.response.map((not) => {
            
            var notIsRead = not.usersIDs && Array.isArray(not.usersIDs) ? not.usersIDs.find(x => x.userID == user.id) : null;
            const notification = {
              notificationID: not.notificationID,
              image: "",
              message: not.description,
              detailPage: "",
              created: not.created,
              receivedTime: moment(not.created).add(moment().utcOffset(), "m").fromNow(),
              isRead: notIsRead != null ? notIsRead.isRead : false
            }
            if(notification.isRead == false) {
              countNotRead = (countNotRead + 1);
            }
            list.push(notification)
          })
          setData(prevData => {
            var existingIds = prevData.map(n => n.notificationID);
            var newNotifications = list.filter(n => !existingIds.includes(n.notificationID));
            var updatedData = [...prevData, ...newNotifications];
            dataRef.current = updatedData;
            return updatedData;
          })
          setCount(countNotRead);
        }
      }).catch((error) => {
        exceptionNotificationAPI(error);
      })
    }    
    , 180000);
    return () => clearInterval(timer);
  }, []);

  const getData = async () => {
    const user = JSON.parse(localStorage.getItem('@QualityApp:user'));
    const userRoles = JSON.parse(localStorage.getItem('@QualityApp:userRoles'));

    await Api.get(`Notification/GetByUserId`).then((result) => {
      if (result && result.data && result.data.response && Array.isArray(result.data.response)) {
        var list = [];
        var countNotRead = 0;
        result.data.response.map((not) => {
          
          var notIsRead = not.usersIDs && Array.isArray(not.usersIDs) ? not.usersIDs.find(x => x.userID == user.id) : null;

          const notification = {
            notificationID: not.notificationID,
            image: "",
            message: not.description,
            detailPage: "",
            created: not.created,
            receivedTime: moment(not.created).add(moment().utcOffset(), "m").fromNow(),
            isRead: notIsRead ? notIsRead.isRead : false
          }
          if(notification.isRead == false) {
            countNotRead = (countNotRead + 1);
          }
          list.push(notification)
          setCount(countNotRead);
        })
        setData(list)
        dataRef.current = list;
        setCount(countNotRead);
        setLoading(false)
      } else {
        setData([]);
        setLoading(false);
      }
    }).catch((error) => {
      exceptionNotificationAPI(error);
      setData([]);
      setLoading(false);
    });
  }

  const onReadAll = async () => {
    if (data && Array.isArray(data)) {
      const promises = data.map(async (notify) => {
        if (!notify.isRead) {
          await Api.post(`Notification/UpdateIRead?id=${notify.notificationID}`);
        }
      });
      await Promise.all(promises);
      
      setData(prevData => 
        prevData.map(notify => ({ ...notify, isRead: true }))
      );
      setCount(0);
    }
  };

  const markAsRead = async (notification) => {
    if (notification && !notification.isRead) {
      await Api.post(`Notification/UpdateIRead?id=${notification.notificationID}`).then((result) => {
        setData(prevData => 
          prevData.map(n => 
            n.notificationID === notification.notificationID 
              ? { ...n, isRead: true }
              : n
          )
        );
        setCount(prevCount => Math.max(0, prevCount - 1));
      }).catch((error) => {
        exceptionNotificationAPI(error);
      });
    }
  };


  return (
    <Container>
      <div style={{ marginBottom: 100 }}>
        {data != null && (
          <NotificationsMenu
            data={data}
            header={{
              title: "Notifications",
              style: { color: "#000" },
              option: {
                text: 'Mark all as read',
                onClick: onReadAll
              }
            }}
            markAsRead={markAsRead}
          />
        )}
      </div>
    </Container>
  );
}

export default NotificationMenu;
